module.exports = __webpack_public_path__ + "img/substation-img_4.1ea9928c.png";